import Navbar from "@/components/Navbar";
import UserChannels from "@/components/UserChannels";
import TokenDisplay from "@/components/TokenDisplay";
import GibRating from "@/components/GibRating";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import ImageHoverPopup from "@/components/ui/image-hover-popup";
import { Badge } from "@/components/ui/badge";
import { Building2, Briefcase, Users, Target, MapPin, Mail, Linkedin, ExternalLink, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
const CharlesHardyProfile = () => {
  const user = {
    name: "Charles Hardy, AIA, CCM",
    role: "GSA Knowledge Network Ambassador",
    title: "GSA's Public Buildings Service",
    email: "charles.hardy@gsa.gov",
    location: "Washington, DC",
    solutionBounties: 5,
    domains: ["Architecture", "Design Leadership", "Workplace Strategy", "Construction Management", "Federal Real Estate", "Innovation", "Project Delivery", "Integrated Design", "Government Operations"],
    industries: [{
      name: "Government",
      icon: Briefcase
    }, {
      name: "Architecture",
      icon: Building2
    }, {
      name: "Construction",
      icon: Target
    }, {
      name: "Real Estate",
      icon: Building2
    }],
    confirmedSolutions: 45,
    confirmedKnowledgeBases: 78,
    tokenBalance: 290,
    bio: "Serves as the Chief Architect of the General Services Administration's Public Buildings Service. As the agency's lead executive in charge of Design and workplace strategy heads the agency's efforts across the country with support in vital areas such as design and construction, real estate services, and procurement. Responsible for research, innovation, and development in the delivery of innovative workplace solutions throughout the federal government. Previously served as Director of Design and Construction, Regional Recovery Executive, Director of Property Development; and Director of Construction. Before joining GSA, was an architect with firms in Florida, Colorado, and Illinois practicing in the areas of real estate development and commercial architectural design. Also a retired officer of the U.S. Air Force."
  };
  return <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6 col-span-2">
            <div className="flex items-start justify-between mb-6">
              <div className="flex items-start space-x-6">
                <div className="flex flex-col items-center gap-4">
                  <ImageHoverPopup imageSrc="/lovable-uploads/98664e7f-474c-4539-a2e4-e908d8f67306.png" imageAlt="Charles Hardy">
                    <Avatar className="h-36 w-36 cursor-pointer">
                      <AvatarImage src="/lovable-uploads/98664e7f-474c-4539-a2e4-e908d8f67306.png" alt="Charles Hardy" className="object-cover" />
                      <AvatarFallback className="bg-blue-100 text-blue-800 text-2xl">CH</AvatarFallback>
                    </Avatar>
                  </ImageHoverPopup>
                  <UserChannels />
                  <div className="w-full">
                    <h3 className="font-serif text-xl font-semibold text-black mb-3">Industries</h3>
                    <div className="grid grid-cols-1 gap-2">
                      {user.industries.map(industry => {
                      const Icon = industry.icon;
                      return <div key={industry.name} className="flex items-center space-x-2 p-3 border-2 border-black rounded-lg">
                            <Icon className="h-5 w-5 text-black" />
                            <span className="text-sm font-medium text-black">{industry.name}</span>
                          </div>;
                    })}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <ImageHoverPopup imageSrc="/lovable-uploads/98664e7f-474c-4539-a2e4-e908d8f67306.png" imageAlt="Charles Hardy">
                      <h2 className="font-serif text-3xl font-bold text-black cursor-pointer hover:text-primary transition-colors">{user.name}</h2>
                    </ImageHoverPopup>
                    <a href={`mailto:${user.email}`} className="inline-flex items-center text-blue-600 hover:text-blue-800">
                      <Mail size={18} className="mr-1" />
                      <span className="text-sm">{user.email}</span>
                    </a>
                  </div>
                  <div className="flex items-center mb-1">
                    <p className="text-lg font-medium text-black">{user.title}</p>
                  </div>
                  <div className="flex items-center mb-4">
                    
                    <Link to="/gsa-channel" className="flex items-center hover:opacity-90 ml-2">
                      <img src="/lovable-uploads/3e0cc269-0dd5-40b5-a1f0-0ebbe7e85733.png" alt="GSA" className="h-10 w-10 hover:scale-110 transition-transform duration-200" />
                    </Link>
                  </div>
                  <div className="flex items-center gap-2 mb-4">
                    <MapPin className="h-4 w-4 text-gray-600" />
                    <span className="text-gray-600">{user.location}</span>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Solution Bounties</h3>
                        <span className="text-4xl font-bold mb-2">{user.solutionBounties}</span>
                        <Link to="/solution-bounties/charles" className="text-sm text-blue-600 hover:text-blue-800">
                          View Details →
                        </Link>
                      </div>
                    </Card>
                    <GibRating rating={9.1} />
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Confirmed Solutions</h3>
                        <span className="text-4xl font-bold">{user.confirmedSolutions}</span>
                      </div>
                    </Card>
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Knowledge Bases</h3>
                        <span className="text-4xl font-bold">{user.confirmedKnowledgeBases}</span>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="font-serif text-xl font-semibold text-black mb-3">Education & Credentials</h3>
              <div className="space-y-3">
                <div className="flex items-start">
                  <GraduationCap className="h-5 w-5 text-gray-600 mr-2 mt-1" />
                  <div>
                    <p className="font-medium">Bachelor of Architecture & Bachelor of Environmental Design</p>
                    <p className="text-gray-600">University of Minnesota</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <GraduationCap className="h-5 w-5 text-gray-600 mr-2 mt-1" />
                  <div>
                    <p className="font-medium">Executive Program Certificates</p>
                    <p className="text-gray-600">Harvard University & University of Texas</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Badge variant="outline" className="mr-2 mt-1">AIA</Badge>
                  <Badge variant="outline" className="mr-2 mt-1">CCM</Badge>
                  <span className="text-gray-600">Licensed Architect & Certified Construction Manager</span>
                </div>
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="font-serif text-xl font-semibold text-black mb-3">Key Experience</h3>
              <div className="space-y-4">
                <div className="border-l-4 border-blue-500 pl-4">
                  <h4 className="font-semibold text-black">Chief Architect</h4>
                  <p className="text-gray-600 text-sm">GSA | Aug 2020 - Present | 5 years</p>
                  <p className="text-gray-700 mt-2">
                    Leading the agency's design and workplace strategy efforts across the country with support in vital areas 
                    such as design and construction, real estate services, and procurement.
                  </p>
                </div>
                <div className="border-l-4 border-teal-500 pl-4">
                  <h4 className="font-semibold text-black">Chief Workplace Officer, Director Center for Workplace Strategy</h4>
                  <p className="text-gray-600 text-sm">GSA | Dec 2011 - Aug 2022 | 10 years 9 months</p>
                  <p className="text-gray-700 mt-2">
                    Responsible for research, innovation, and development in the delivery of innovative workplace solutions 
                    throughout the federal government.
                  </p>
                </div>
                <div className="border-l-4 border-green-500 pl-4">
                  <h4 className="font-semibold text-black">Regional Recovery Executive</h4>
                  <p className="text-gray-600 text-sm">GSA | Apr 2009 - Jan 2012 | 2 years 10 months</p>
                  <p className="text-gray-700 mt-2">
                    Led recovery efforts and strategic initiatives during a critical period for federal infrastructure development.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="font-serif text-xl font-semibold text-black mb-3">Professional Leadership</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <p className="text-gray-700">• Ex-officio Board Member, Construction Managers Association of America</p>
                  <p className="text-gray-700">• Trustee, Construction Users Roundtable (CURT)</p>
                  <p className="text-gray-700">• Board of Directors, Chicago ACE Mentor Program</p>
                </div>
                <div className="space-y-2">
                  <p className="text-gray-700">• Member, AGC Public-Private Industry Advisory Council</p>
                  <p className="text-gray-700">• Published in AIA Architect Magazine</p>
                  <p className="text-gray-700">• Retired U.S. Air Force Officer</p>
                </div>
              </div>
            </div>
          </Card>
          
          <div className="space-y-6">
            <TokenDisplay balance={user.tokenBalance} />
            <Card className="p-6">
              <h3 className="font-serif text-xl font-semibold text-black mb-3">Domains</h3>
              <div className="flex flex-wrap gap-2">
                {user.domains.map(domain => <Badge key={domain} variant="outline" className="border-2 border-black text-black">
                    {domain}
                  </Badge>)}
              </div>
            </Card>
          </div>
        </div>
      </main>
    </div>;
};
export default CharlesHardyProfile;